/* KORE Scrolly — motor de scroll pin + scrub (v5)
   Ancla una sección al viewport y desbloquea sus pasos al ritmo del scroll:
   el usuario "gasta" scroll dentro de la sección hasta revelarlo todo y
   después la página continúa. Bidireccional: subir vuelve a bloquear.

   Uso en Liquid:
     <div class="kore-pin" data-kore-pin>
       <div class="kore-pin__stage">
         <section> ... elementos con data-pin-step ... </section>
       </div>
     </div>

   - [data-pin-step]            paso que se desbloquea por orden (clase .is-on)
   - [data-pin-step="0.12"]     umbral explícito de progreso (0..1)
   - [data-pin-scrub="a b"]     recibe --kore-seg (0..1) mapeando el progreso [a..b]
   - [data-pin-extra="0.5"]     scroll extra del wrapper, en fracciones de viewport
   - El wrapper activo expone --kore-p (progreso 0..1) para CSS (líneas, barras…)

   Mejora progresiva: si el contenido no cabe en el viewport (móvil), si el
   usuario prefiere menos movimiento o si el JS no carga, la sección se queda
   con el reveal clásico .kore-anim por IntersectionObserver. */
(function () {
  'use strict';
  if (window.KoreScrolly) return;
  window.KoreScrolly = true;

  /* CSS inyectado desde JS: solo tiene sentido cuando el motor está activo,
     así que no puede provocar FOUC si el script no llega a ejecutarse. */
  var ease = 'cubic-bezier(.22,.61,.36,1)';
  var style = document.createElement('style');
  style.textContent =
    '[data-kore-pin]{position:relative}' +
    '.kore-pin--on>.kore-pin__stage{position:sticky;top:0;height:100vh;height:100svh;display:flex;flex-direction:column;overflow:hidden}' +
    '.kore-pin--on>.kore-pin__stage>*{flex:1 0 auto;display:flex;flex-direction:column;justify-content:center;min-height:0}' +
    '.kore-pin--on [data-pin-step]{transition:opacity .6s ' + ease + ',transform .6s ' + ease + '!important;transition-delay:0s!important}' +
    '.kore-pin--on [data-pin-step]:not(.is-on){opacity:0!important;transform:translateY(34px)!important}' +
    '.kore-pin--on [data-pin-step].is-on{opacity:1!important;transform:none!important}';
  document.head.appendChild(style);

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var pins = [];
  var rafId = 0;
  var lastW = 0;
  var lastH = 0;

  function clamp01(v) { return v < 0 ? 0 : v > 1 ? 1 : v; }

  function setup() {
    lastW = window.innerWidth;
    lastH = window.innerHeight;
    var wraps = Array.prototype.slice.call(document.querySelectorAll('[data-kore-pin]'));
    /* 1) Estado base + clase de medición: .kore-pin--fit aplica la versión
       compacta de cada sección ANTES de medir (si midiéramos la versión
       espaciada, casi ninguna sección "cabría" y nunca se anclaría). */
    wraps.forEach(function (w) {
      w.classList.remove('kore-pin--on');
      w.style.height = '';
    });
    pins = [];
    if (reduce.matches) {
      wraps.forEach(function (w) { w.classList.remove('kore-pin--fit'); });
      return;
    }
    wraps.forEach(function (w) { w.classList.add('kore-pin--fit'); });
    var vh = window.innerHeight;
    /* 2) Medir todo antes de activar nada (evita thrash de layout) */
    var measured = wraps.map(function (w) {
      var stage = w.querySelector('.kore-pin__stage');
      return { w: w, stage: stage, h: stage ? stage.offsetHeight : 0 };
    });
    /* 3) Activar solo las secciones que caben en pantalla (compactadas);
       el resto vuelve a su versión espaciada con el reveal clásico */
    measured.forEach(function (m) {
      if (!m.stage) return;
      if (vh < 480 || m.h > vh - 24) {
        m.w.classList.remove('kore-pin--fit');
        return;
      }
      var n0 = m.w.querySelectorAll('[data-pin-step]').length;
      var idx = 0;
      var steps = Array.prototype.slice.call(m.w.querySelectorAll('[data-pin-step]')).map(function (el) {
        var attr = parseFloat(el.getAttribute('data-pin-step'));
        var th = (attr > 0 && attr <= 1) ? attr : (idx + 1) / (n0 + 1);
        idx += 1;
        return { el: el, th: th };
      });
      var scrubs = Array.prototype.slice.call(m.w.querySelectorAll('[data-pin-scrub]')).map(function (el) {
        var p = (el.getAttribute('data-pin-scrub') || '').split(/[\s,]+/);
        var a = parseFloat(p[0]);
        var b = parseFloat(p[1]);
        return { el: el, a: isNaN(a) ? 0 : a, b: isNaN(b) ? 1 : b };
      });
      if (!steps.length && !scrubs.length) {
        m.w.classList.remove('kore-pin--fit');
        return;
      }
      /* Scroll "gastado" por paso + cola final para asentar la escena.
         Con muchos pasos se acorta cada tramo para no eternizar la sección.
         data-pin-per="0.3" fija el tramo por paso en fracciones de viewport. */
      var perAttr = parseFloat(m.w.getAttribute('data-pin-per'));
      var per = perAttr > 0
        ? Math.max(140, perAttr * vh)
        : Math.max(200, Math.min(vh * (steps.length > 5 ? 0.3 : 0.42), 440));
      var extra = parseFloat(m.w.getAttribute('data-pin-extra')) || 0;
      var len = Math.round(steps.length * per + (extra + 0.18) * vh);
      m.w.classList.add('kore-pin--on');
      m.w.style.height = (vh + len) + 'px';
      pins.push({ w: m.w, steps: steps, scrubs: scrubs, len: len, last: -1 });
    });
    update();
  }

  function update() {
    rafId = 0;
    for (var i = 0; i < pins.length; i++) {
      var p = pins[i];
      var prog = clamp01(-p.w.getBoundingClientRect().top / p.len);
      if (prog === p.last) continue;
      p.last = prog;
      p.w.style.setProperty('--kore-p', prog.toFixed(4));
      for (var j = 0; j < p.steps.length; j++) {
        p.steps[j].el.classList.toggle('is-on', prog >= p.steps[j].th - 0.0001);
      }
      for (var k = 0; k < p.scrubs.length; k++) {
        var s = p.scrubs[k];
        s.el.style.setProperty('--kore-seg', clamp01((prog - s.a) / (s.b - s.a)).toFixed(4));
      }
    }
  }

  function onScroll() {
    if (!rafId && pins.length) rafId = requestAnimationFrame(update);
  }

  var resizeTimer = 0;
  function onResize() {
    /* Ignorar el vaivén de la barra de URL en móvil: solo altura y poca */
    if (window.innerWidth === lastW && Math.abs(window.innerHeight - lastH) < 140) return;
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(setup, 180);
  }

  /* El tema desplaza .page-wrapper (no window) en escritorio: capture:true
     recoge el scroll de cualquier contenedor. */
  document.addEventListener('scroll', onScroll, { capture: true, passive: true });
  window.addEventListener('resize', onResize);
  window.addEventListener('load', setup);
  document.addEventListener('shopify:section:load', setup);
  if (reduce.addEventListener) reduce.addEventListener('change', setup);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();
